import { currentLocale } from '@trello/locale';

// eslint-disable-next-line @trello/enforce-variable-case
const PluginOptions = (baseOptions) => ({
  ...baseOptions,
  locale: currentLocale,
});

export { PluginOptions };
